import React  from 'react';
import { withRouter } from 'react-router';
import storageService from '../../shared/services/StorageService';

/* Redux Import Start */
import { connect } from 'react-redux';
/* Redux Import End */

function guardStepProcess(Component) {
    class guardStepProcessComponent extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                validTab: false
            }
        }

        /**
         * componentWillMount()
         * This function Executes just before rendering takes place.
         */
        componentWillMount = async() => {
            this.checkAuth();
        }
        
        /**
         * checkAuth()
         * This function will act as a guard to redirect based on the conditions.
         */
        checkAuth = async() => {
            try {
                const { activeTab, accessToken, quoteOnlyUser, location, history } = this.props;
                let accessTokenfromStore = await storageService.getSessionStorageItem("accessToken");
                const { pathname, search } = location;
                const redirect = pathname + search;

                if (!accessTokenfromStore) {
                    history.push(`/login`);
                    return;
                }

                if ( accessToken === '' || (redirect !== "/quote-only" && quoteOnlyUser)) {
                    history.push(`/login`);
                    return;
                }

                const tabRoutes = {
                    getEstimate: '/request-bungii',
                    deliveryDetails: '/delivery-details',
                    done: '/success',
                    dashboard: '/dashboard',
                };

                const expectedRoute = tabRoutes[activeTab];

                if (expectedRoute && redirect !== expectedRoute) {
                    history.push(expectedRoute);
                    return;
                }

                this.setState({
                    validTab: true
                })
            } catch (err) {
                console.error(err);
                this.props.history.push(`/login`);
            }
        }

        render() {
            return this.state.validTab ? <Component { ...this.props } /> : null;
        }
    }
    
    return connect(
        (
            { 
                user: {
                    accessToken,
                    quoteOnlyUser,
                },
                common: {
                    activeTab
                }
            }
        ) => 
        (
            {
                accessToken,
                activeTab,
                quoteOnlyUser,
            }
        ),
        ''
    )(withRouter(guardStepProcessComponent));
}

export default guardStepProcess;